import React, { useEffect, useState } from "react";
import CustomModal from "../Modals/CustomModal";
import AuthInput from "../Input/AuthInput";
import AuthBtn from "../Buttons/AuthBtn";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { EditCustomerApi } from "../../ApiRequests";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";

const EditReceivableContactModal = ({ open, setOpen, customer, onUpdated }) => {
  const [contact, setContact] = useState("");
  const [contact2, setContact2] = useState("");
  const [pageNo, setPageNo] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customer) return;
    setContact(customer.contact || "");
    setContact2(customer.contact2 || "");
    setPageNo(customer.page_no || "");
  }, [customer, open]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!customer?._id) return;

    if (!contact.trim()) {
      WarningToast("Enter a valid contact number");
      return;
    }
    if (!pageNo.trim()) {
      WarningToast("Enter a valid page number");
      return;
    }

    setLoading(true);
    try {
      const response = await EditCustomerApi(customer._id, {
        contact: contact.trim(),
        contact2: contact2.trim(),
        page: pageNo.trim(),
      });
      if (response.data.success) {
        SuccessToast("Contact details updated");
        setOpen(false);
        onUpdated?.(response.data.data.payload);
      } else {
        ErrorToast(response.data.error?.msg || "Update failed");
      }
    } catch (err) {
      ErrorToast(err.response?.data?.error?.msg || "Failed to update contact");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal open={open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-2xl py-6 px-4">
          Update contact & page
        </h1>
        {customer?.name && (
          <p className="text-center text-sm text-muted -mt-2 mb-4 px-6 truncate">
            {customer.name}
          </p>
        )}
        <div className="flex flex-col px-8 gap-y-4">
          <AuthInput
            label="Contact 1"
            placeholder="Enter primary contact"
            Value={contact}
            setValue={setContact}
          />
          <AuthInput
            label="Contact 2"
            placeholder="Enter second contact (optional)"
            Value={contact2}
            setValue={setContact2}
          />
          <AuthInput
            label="Page No"
            placeholder="Enter page number"
            Value={pageNo}
            setValue={setPageNo}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-6 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Save" onSubmit={onSubmit} type={1} />
              <AuthBtn title="Cancel" onSubmit={() => setOpen(false)} type={2} />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditReceivableContactModal;
